import React from 'react'
import Accordion from 'components/molecules/Accordion'
import './ContactsAccordion.scss'
import get from 'lodash.get'

function ContactsAccordion({categories}) {

  return (
    <section className="contacts-accordion">
      <ul className="contacts-accordion__list">
        {categories.map((item, index) => (
          <li className="contacts-accordion__list-item" key={index}>
            <p className="contacts-accordion__list-title">{get(item, 'entity.name')}</p>

            <Accordion type="contact" items={get(item, 'entity.phones.entities') || []} className="contact-accordion" />
          </li>
        ))}
      </ul>
    </section>
  )
}

export default ContactsAccordion
